import { render, staticRenderFns } from "./AddSQL.vue?vue&type=template&id=2afd7968&scoped=true"
import script from "./AddSQL.vue?vue&type=script&lang=js"
export * from "./AddSQL.vue?vue&type=script&lang=js"
import style0 from "./AddSQL.vue?vue&type=style&index=0&id=2afd7968&scoped=true&lang=css"
import style1 from "./AddSQL.vue?vue&type=style&index=1&id=2afd7968&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd7968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afd7968')) {
      api.createRecord('2afd7968', component.options)
    } else {
      api.reload('2afd7968', component.options)
    }
    module.hot.accept("./AddSQL.vue?vue&type=template&id=2afd7968&scoped=true", function () {
      api.rerender('2afd7968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/AddSQL.vue"
export default component.exports